import {
    loadingMap,
    getActionMap,
    getModule,
    getModuleName,
    getModules,
    getAcl,
    getUrl,
    getTools,
    getTool,
    getStateTools,
    getStateTool,
    getPanel,
    getPanelStatus,
    isPanelVisible,
    isPanelActive,
    getPanels,
    getConfig,
    getProjectionsMap,
    getConfigMap,
} from '@/app/shared/utils/stateGetterUtils';

const getters = {
    loadingMap: state => loadingMap(state),
    getActionMap: state => getActionMap(state),
    getCodeModule: state => state.data.code,
    getCodeApiModule: state => state.data.codeAPI,
    getModule: state => getModule(state),
    getModuleName: state => getModuleName(state),
    getModules: state => getModules(state),
    getTools: state => getTools(state),
    getTool: (state) => (id) => {
        return getTool(state, id);
    },
    getAcl: (state, getters) => (id) => {
        return getAcl(state, getters.getTools, id);
    },
    getUrl: (state, getters) => (id) => {
        return getUrl(state, getters.getTools, id);
    },
    getStateTools: (state, getters) => {
        return getStateTools(state, getters);
    },
    getStateTool: (state, getters) => (id) => {
        return getStateTool(state, getters, id);
    },
    getPanel: (state, getters) => (id) => {
        return getPanel(state, getters.getTools, id);
    },
    isPanelActive: (state, getters) => (id) => {
        return isPanelActive(getters, id);
    },
    isPanelVisible: (state, getters) => (id) => {
        return isPanelVisible(getters, id);
    },
    getPanels: (state, getters) => {
        return getPanels(state, getters.getTools);
    },
    getPanelStatus: (state, getters) => (id) => {
        return getPanelStatus(state, getters, id);
    },
    getConfig: (state) => (id) => {
        return getConfig(state, id);
    },
    getConfigMap: (state, rootState) => {
        return getConfigMap(state, rootState);
    },
    getProjectionsMap: (state) => {
        return getProjectionsMap(state);
    },
    getUserFeatureMap: state => state.data.map.user_feature,
    getFilterStatusMap: state => state.data.map.filters.status,
    getFilterTypesMap: state => state.data.map.filters.types,
};

export default getters;